import React from "react";
import { default as AVATAR } from "@material-ui/core/Avatar";

interface IpropesAvatar {
  className?: any;
  onClick?: any;
  src?: string;
  children?: any;
  style?: any;
  classes?: any;
  alt?: string;
}

export const Avatar = (props: IpropesAvatar) => {
  let { className, alt, onClick, src, style, classes, children } = props;
  return (
    <AVATAR
      className={className}
      alt={alt}
      src={src}
      onClick={onClick}
      style={style}
      classes={classes}
    >
      {children}
    </AVATAR>
  );
};
